// extracted by mini-css-extract-plugin
module.exports = {"CardContainerItem":"ConfigurationScreenContentGenresItem__CardContainerItem__3eoy1","PictureUser":"ConfigurationScreenContentGenresItem__PictureUser__2Wbdr"};